<template>
  <b-card>
    <b-card-title class="mb-75">
      Cambios
      <b-spinner
        small
        class="float-right"
        variant="primary"
        v-if="isLoading"
      />
    </b-card-title>
    <div class="activity-timeline mt-4">
      <app-timeline>
        <app-timeline-item
          v-for="item in items"
          :key="item.id"
          :title="item.title"
          :subtitle="item.subtitle"
          :icon="item.icon"
          :time="item.date | fromNow"
          :variant="item.status"
        />
      </app-timeline>
    </div>
  </b-card>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import AppTimeline from '@core/components/app-timeline/AppTimeline';
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem';
import {
  getBinnacleOfActivity,
  isBinnacleOfActivityLoading
} from '@/febos/global/kanban/store/getters';
import { fetchActivityBinnacle } from '@/febos/global/kanban/store/actions';

export default {
  computed: {
    ...mapGetters('kanban', {
      getBinnacleOfActivity: getBinnacleOfActivity.name,
      isBinnacleOfActivityLoading: isBinnacleOfActivityLoading.name,
    }),
    items() {
      return this.getBinnacleOfActivity(this.activityId);
    },
    isLoading() {
      return this.isBinnacleOfActivityLoading(this.activityId);
    }
  },
  methods: {
    ...mapActions('kanban', {
      fetchActivityBinnacle: fetchActivityBinnacle.name
    })
  },
  created() {
    this.fetchActivityBinnacle({ activityId: this.activityId });
  },
  components: {
    AppTimeline,
    AppTimelineItem
  },
  props: {
    activityId: { type: [Number, String], required: true }
  }
};

</script>
